import sanityClient from '@sanity/client'
import { Link } from 'gatsby'
import React from 'react'
import usePromise from 'react-use-promise'

import { getUrlForType } from '../../lib/helpers'

// * From /studio/sanity.json
const client = sanityClient({
  projectId: 'uf1om34c',
  dataset: 'production',
  token: process.env.SANITY_TOKEN,
  useCdn: false
})

const InternalLink = ({ children, mark }) => {
  const [doc, errors, status] = usePromise(
    () => client.getDocument(mark.item._ref),
    []
  )
  if (errors && errors.length) {
    throw new Error(errors.join(' '))
  }
  if (status !== 'resolved') {
    return <span>'Loading...'</span>
  }
  return <Link to={getUrlForType(doc._createdAt, doc.slug.current, doc._type)}>{children}</Link>
}

export default InternalLink
